/* melee-v2-compare.js — migrated out of sections/melee-v2-compare.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initCompare(root) {
      if (!root || root.dataset.mv2CompareReady === '1') return;
      root.dataset.mv2CompareReady = '1';

      /* ---- responsive image swap: desktop/mobile crop per layer ---- */
      (function compareResponsive() {
        var mq = matchMedia('(max-width: 760px)');
        var imgs = Array.prototype.slice.call(root.querySelectorAll('.mv2-compare__layer img'));
        if (!imgs.length) return;

        // preload BOTH crops for every layer so a resize never waits on the network
        imgs.forEach(function (img) {
          ['data-src-desktop', 'data-src-mobile'].forEach(function (a) {
            var u = img.getAttribute(a);
            if (u) {
              var pre = new Image();
              pre.src = u;
            }
          });
        });

        function apply() {
          var mobile = mq.matches;
          imgs.forEach(function (img) {
            var want = img.getAttribute(mobile ? 'data-src-mobile' : 'data-src-desktop');
            if (!want || img.getAttribute('src') === want) return;
            img.style.opacity = '0';
            var up = function () {
              img.style.opacity = '1';
              img.removeEventListener('load', up);
            };
            img.addEventListener('load', up);
            img.src = want;
            if (img.complete) up();
            setTimeout(up, 250);
          });
        }

        apply();
        if (mq.addEventListener) mq.addEventListener('change', apply);
        else if (mq.addListener) mq.addListener(apply);
      })();

      /* ---- scroll wipe (phase 1) + drag slider (phase 2) ---- */
      var CONFIG = {
        wipeStart: 0.06,
        wipeEnd: 0.5,
        actAt: 0.52,
        hintTo: 0.5,
        hintMs: 650,
        smooth: 0.14,
      };

      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      var sticky = root.querySelector('.mv2-compare__sticky');
      var frame = root.querySelector('[data-mv2-compare-frame]');
      var wipeTop = root.querySelector('[data-mv2-compare-wipe]');
      var compareTop = root.querySelector('[data-mv2-compare-top]');
      var handle = root.querySelector('[data-mv2-compare-handle]');
      var seam = root.querySelector('[data-mv2-compare-seam]');
      if (!frame || !handle) return;

      var statsA = frame.querySelectorAll('.mv2-compare__stat[data-set="a"]');
      var statsB = frame.querySelectorAll('.mv2-compare__stat[data-set="b"]');

      var clamp = function (v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      };
      var map = function (v, a, b) {
        return b === a ? (v >= b ? 1 : 0) : clamp((v - a) / (b - a));
      };
      var smoothstep = function (t) {
        return t * t * (3 - 2 * t);
      };

      var sp = 0,
        targetP = 0,
        rafId = null;
      var v = 1;
      var grabbed = false;
      var hintPlayed = false;
      var hintStart = 0,
        hinting = false;
      var live = false;

      function setLive(on) {
        if (on === live) return;
        live = on;
        handle.classList.toggle('is-live', on);
      }

      function setStats(list, op, dy) {
        var o = op.toFixed(3),
          t = 'translateY(' + dy.toFixed(1) + 'px)';
        for (var i = 0; i < list.length; i++) {
          list[i].style.opacity = o;
          list[i].style.transform = t;
        }
      }

      function applyHandle() {
        if (compareTop) {
          var hideBottom = ((1 - v) * 100).toFixed(3);
          compareTop.style.clipPath = 'inset(0 0 ' + hideBottom + '% 0)';
          compareTop.style.webkitClipPath = 'inset(0 0 ' + hideBottom + '% 0)';
        }
        handle.style.top = (v * 100).toFixed(3) + '%';
        handle.setAttribute('aria-valuenow', String(Math.round(v * 100)));
      }

      function apply(now) {
        if (wipeTop) {
          var pB = smoothstep(map(sp, CONFIG.wipeStart, CONFIG.wipeEnd));
          var hidden = (pB * 100).toFixed(3);
          wipeTop.style.clipPath = 'inset(0 0 ' + hidden + '% 0)';
          wipeTop.style.webkitClipPath = 'inset(0 0 ' + hidden + '% 0)';

          if (seam) {
            if (pB > 0.0005 && pB < 0.9995) {
              seam.style.top = ((1 - pB) * 100).toFixed(3) + '%';
              seam.style.opacity = '1';
            } else {
              seam.style.opacity = '0';
            }
          }
        }

        var shouldLive = sp >= CONFIG.actAt;
        setLive(shouldLive);

        if (shouldLive && !hintPlayed && !grabbed && !hinting) {
          hinting = true;
          hintStart = now;
        }
        if (sp < CONFIG.wipeEnd - 0.06) {
          hintPlayed = false;
          hinting = false;
          if (!grabbed) v = 1;
        }

        if (hinting && !grabbed) {
          var t = clamp((now - hintStart) / CONFIG.hintMs);
          v = 1 + (CONFIG.hintTo - 1) * smoothstep(t);
          if (t >= 1) {
            hinting = false;
            hintPlayed = true;
          }
        }

        var RISE = 46;
        var aOut = smoothstep(map(sp, 0.34, 0.48));
        setStats(statsA, 1 - smoothstep(clamp((aOut - 0.5) / 0.5)), -aOut * RISE);
        var bRaw = map(sp, 0.56, 0.72);
        setStats(statsB, smoothstep(clamp(bRaw / 0.4)), (1 - smoothstep(bRaw)) * RISE);

        applyHandle();
      }

      function computeTarget() {
        // A sticky child pins for exactly (parent height − its own height),
        // and starts pinning once the parent has scrolled past its `top`
        // offset — not necessarily 0. Reading both from the real rendered
        // element (rather than assuming the sticky child fills the full
        // window.innerHeight starting at the very top) keeps this in sync
        // with whatever `top`/`height` the CSS uses, including the navbar
        // offset above.
        var rect = root.getBoundingClientRect();
        var stickyTopOffset = 0;
        var stickyHeight = window.innerHeight;
        if (sticky) {
          stickyTopOffset = parseFloat(getComputedStyle(sticky).top) || 0;
          stickyHeight = sticky.getBoundingClientRect().height || stickyHeight;
        }
        var scrollable = rect.height - stickyHeight;
        targetP = scrollable > 0 ? clamp((stickyTopOffset - rect.top) / scrollable) : 0;
      }

      function tick(now) {
        var diff = targetP - sp;
        var easing = Math.abs(diff) >= 0.0004;
        if (easing) sp += diff * CONFIG.smooth;
        else sp = targetP;
        apply(now || performance.now());
        if (easing || hinting) {
          rafId = requestAnimationFrame(tick);
        } else {
          rafId = null;
        }
      }
      function requestTick() {
        if (rafId == null) rafId = requestAnimationFrame(tick);
      }

      function onScroll() {
        computeTarget();
        if (reduce) {
          sp = targetP;
          apply(performance.now());
          requestTick();
          return;
        }
        requestTick();
      }
      function onResize() {
        computeTarget();
        apply(performance.now());
      }

      function yToV(clientY) {
        var r = frame.getBoundingClientRect();
        return clamp((clientY - r.top) / r.height);
      }
      function onDown(e) {
        if (!live) return;
        // On touch/pen, only a press that actually starts on the handle
        // (the visible grip circle) may begin a drag -- grabbing from
        // anywhere in the full-bleed frame (the old behavior, still kept
        // for mouse) meant every scroll swipe over this pinned section
        // got hijacked into the slider the moment it went live. Requiring
        // the deliberate grab is the "extra effort" that keeps normal
        // page scrolling free everywhere except the handle itself.
        if (e.pointerType !== 'mouse' && e.target !== handle && !handle.contains(e.target)) return;
        grabbed = true;
        hinting = false;
        hintPlayed = true;
        frame.setPointerCapture && frame.setPointerCapture(e.pointerId);
        v = yToV(e.clientY);
        applyHandle();
        e.preventDefault();
      }
      function onMove(e) {
        if (!grabbed) return;
        v = yToV(e.clientY);
        applyHandle();
        e.preventDefault();
      }
      function onUp(e) {
        if (!grabbed) return;
        grabbed = false;
        try {
          frame.releasePointerCapture(e.pointerId);
        } catch (_) {}
      }
      function onKey(e) {
        if (!live) return;
        var step = e.shiftKey ? 0.1 : 0.03;
        if (e.key === 'ArrowUp') {
          v = clamp(v - step);
          hintPlayed = true;
          applyHandle();
          e.preventDefault();
        } else if (e.key === 'ArrowDown') {
          v = clamp(v + step);
          hintPlayed = true;
          applyHandle();
          e.preventDefault();
        }
      }

      frame.addEventListener('pointerdown', onDown);
      frame.addEventListener('pointermove', onMove);
      frame.addEventListener('pointerup', onUp);
      frame.addEventListener('pointercancel', onUp);
      handle.addEventListener('keydown', onKey);

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      computeTarget();
      sp = targetP;
      apply(performance.now());
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-compare]').forEach(initCompare);
    }

    ready(initAll);
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-mv2-compare]') : null;
      if (root) {
        root.dataset.mv2CompareReady = '0';
        initCompare(root);
      }
    });
  })();
